import formValidation from '@assets/components/formValidation';
import { setCookie, getCookie } from './utility';

export default class Newsletter {
    constructor() {
        this.form = $('.form-newsletter__form');
        this.input = this.form.find('.form-newsletter__input');
        this.NewsletterModal = $('#newsletter-modal');
    }

    init() {
        this.onFormSubmit();
        if (this.NewsletterModal.length <= 0) return;
        this.showNewsletterModal();
        this.onQuitModal();
    }

    showNewsletterModal() {
        if (!getCookie('newsletter')) {
            const sessionNewsletter = sessionStorage.getItem('newsletter');
            switch (sessionNewsletter) {
            case null:
                sessionStorage.setItem('newsletter', 1);
                break;
            case '1':
                sessionStorage.setItem('newsletter', 2);
                break;
            case '2':
                setTimeout(() => {
                    $('#newsletter-modal').modal('show');
                }, 3000);
                break;
            default:
                break;
            }
        }
    }

    onFormSubmit() {
        this.form.on('submit', (e) => {
            e.preventDefault();
            const $form = $(e.target);
            const formUrl = $form.attr('action');
            const formData = $form.serialize();

            $.ajax({
                url: formUrl,
                method: 'POST',
                data: formData,
                beforeSend: $form.spinner().start(),
                success(data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        const thanksElement = `<p class="small">${data.message || window.Resources.forms['form.thankyou.newsletter']}</p>`;
                        $form.parent().html(thanksElement);
                    }
                },
                error(xhr) {
                    $form.spinner().stop();

                    const responseJSON = xhr.responseJSON || {};
                    const { redirectUrl, message } = responseJSON;
                    const displayMessage = message || window.Resources.error['message.error.general'];

                    if (redirectUrl) {
                        window.location.href = redirectUrl;
                    } else if (displayMessage && displayMessage.length) {
                        formValidation($form, { error: [displayMessage] });
                    }
                },
            });

            return false;
        });
    }

    onQuitModal() {
        this.NewsletterModal.on(
            'hidden.bs.modal',
            setCookie.bind(this, 'newsletter', 'shown', 30),
        );
    }
}
